var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.RankingHeader = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _Basic = require("../../../elements/Basic");

var _i18n = _interopRequireDefault(require("../../../i18n"));

var _jsxFileName = "/builds/sport1/libraries/universal-components/lib/components/Universal/Ranking/RankingHeader.js";

var getMainValueLabel = function getMainValueLabel(_ref) {
  var rankingType = _ref.rankingType;

  switch (rankingType) {
    case 'GOALS':
      return (0, _i18n.default)('ranking_header_goals');

    case 'SCORER':
      return (0, _i18n.default)('ranking_header_points');

    case 'ASSISTS':
      return (0, _i18n.default)('ranking_header_assists');

    case 'YELLOW_CARDS':
      return (0, _i18n.default)('ranking_header_yellow_cards');

    case 'RED_CARDS':
      return (0, _i18n.default)('ranking_header_red_cards');

    default:
      return '';
  }
};

var RankingHeader = function RankingHeader(_ref2) {
  var rankingType = _ref2.rankingType,
      headerRowStyles = _ref2.headerRowStyles;
  return [_react.default.createElement(_Basic.Text, (0, _extends2.default)({
    key: "number",
    tableWidth: 9 / 100,
    maxWidth: 45,
    columnStyling: {
      center: true
    }
  }, headerRowStyles, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 23,
      columnNumber: 5
    }
  }), "#"), _react.default.createElement(_Basic.Text, (0, _extends2.default)({
    key: "distance",
    tableWidth: 8 / 100,
    maxWidth: 50,
    columnStyling: {
      center: true
    }
  }, headerRowStyles, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 32,
      columnNumber: 5
    }
  })), _react.default.createElement(_Basic.Text, (0, _extends2.default)({
    key: "name",
    pl: 10,
    columnStyling: {
      alignItems: 'flex-start',
      flexing: true,
      justifyContent: 'center'
    }
  }, headerRowStyles, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 39,
      columnNumber: 5
    }
  }), "Name"), _react.default.createElement(_Basic.Text, (0, _extends2.default)({
    key: "goals",
    tableWidth: 10 / 100,
    maxWidth: 55,
    columnStyling: {
      center: true
    },
    numberOfLines: 1
  }, headerRowStyles, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 47,
      columnNumber: 5
    }
  }), rankingType === 'SCORER' && (0, _i18n.default)('ranking_header_goals')), _react.default.createElement(_Basic.Text, (0, _extends2.default)({
    key: "assists",
    tableWidth: 10 / 100,
    maxWidth: 55,
    columnStyling: {
      center: true
    },
    numberOfLines: 1
  }, headerRowStyles, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 57,
      columnNumber: 5
    }
  }), rankingType === 'SCORER' && (0, _i18n.default)('ranking_header_assists')), _react.default.createElement(_Basic.Text, (0, _extends2.default)({
    key: "rank",
    tableWidth: 10 / 100,
    maxWidth: 55,
    columnStyling: {
      center: true
    },
    numberOfLines: 1
  }, headerRowStyles, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 67,
      columnNumber: 5
    }
  }), getMainValueLabel({
    rankingType: rankingType
  }))];
};

exports.RankingHeader = RankingHeader;
var _default = RankingHeader;
exports.default = _default;